__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "atlas-microfrontend";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@atlashxm/atlasuikit2", "0.52.9", () => (__webpack_require__.e(596).then(() => (() => (__webpack_require__(80596))))));
			register("@atlashxm/atlasuikit", "1.8.29", () => (__webpack_require__.e(8103).then(() => (() => (__webpack_require__(98103))))));
			register("@radix-ui/react-dropdown-menu", "2.1.25", () => (__webpack_require__.e(5243).then(() => (() => (__webpack_require__(35243))))));
			register("@radix-ui/react-navigation-menu", "1.3.0", () => (__webpack_require__.e(3514).then(() => (() => (__webpack_require__(43514))))));
			register("axios", "0.25.0", () => (__webpack_require__.e(2505).then(() => (() => (__webpack_require__(72505))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(6942).then(() => (() => (__webpack_require__(46942))))));
			register("crypto-js", "4.2.0", () => (__webpack_require__.e(1396).then(() => (() => (__webpack_require__(21396))))));
			register("jwt-decode", "3.1.2", () => (__webpack_require__.e(6765).then(() => (() => (__webpack_require__(6765))))));
			register("lodash", "4.18.1", () => (__webpack_require__.e(2543).then(() => (() => (__webpack_require__(2543))))));
			register("lucide-react", "0.513.0", () => (__webpack_require__.e(1794).then(() => (() => (__webpack_require__(91794))))));
			register("moment", "2.31.0", () => (__webpack_require__.e(5093).then(() => (() => (__webpack_require__(95093))))));
			register("posthog-js", "1.375.0", () => (() => (__webpack_require__(55476))), 1);
			register("powerbi-report-component", "2.6.1", () => (__webpack_require__.e(3038).then(() => (() => (__webpack_require__(93038))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(40961))), 1);
			register("react-hook-form", "7.89.0", () => (__webpack_require__.e(9785).then(() => (() => (__webpack_require__(49785))))));
			register("react-i18next", "12.3.1", () => (() => (__webpack_require__(32990))), 1);
			register("react-redux", "7.2.9", () => (__webpack_require__.e(1225).then(() => (() => (__webpack_require__(61225))))));
			register("react-router-dom", "6.2.2", () => (() => (__webpack_require__(28651))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(96540))), 1);
			register("redux-devtools-extension", "2.13.9", () => (__webpack_require__.e(9585).then(() => (() => (__webpack_require__(21966))))));
			register("redux-thunk", "2.4.2", () => (__webpack_require__.e(1265).then(() => (() => (__webpack_require__(1265))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(8238).then(() => (() => (__webpack_require__(68238))))));
			register("reselect", "4.1.8", () => (__webpack_require__.e(2325).then(() => (() => (__webpack_require__(22325))))));
			register("uuid", "8.3.2", () => (__webpack_require__.e(611).then(() => (() => (__webpack_require__(10611))))));
			register("yup", "0.32.11", () => (__webpack_require__.e(2921).then(() => (() => (__webpack_require__(72921))))));
			initExternal(54341);
			initExternal(29328);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};